import { useEffect, useRef } from "react";

// Match on e.code, not e.key: on macOS Option composes a glyph (⌥I is a dead key for ˆ).
export function useInspectShortcut(onToggle: () => void) {
  const ref = useRef(onToggle);
  // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
  ref.current = onToggle;

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.shiftKey &&
        e.altKey &&
        !e.metaKey &&
        !e.ctrlKey &&
        e.code === "KeyI"
      ) {
        e.preventDefault();
        ref.current();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
}
